var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.series.length && _vm.series[0].data.length>0)?_c('apexchart',{attrs:{"width":"700px","height":110,"type":"bar","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }